function setStorage(name, data) {
  localStorage.setItem(name, JSON.stringify(data));
}

function getStorage(name) {
  try {
    return JSON.parse(localStorage.getItem(name));
  } catch {
    return null;
  }
}

function clearStorage() {
  localStorage.clear();
}

function getSessionAuth() {
  const session = getStorage("ctxSession");
  return session?.user ? session : null;
}

export { setStorage, getStorage, clearStorage, getSessionAuth };
